import {Component} from "@angular/core";
import {WorkflowStep} from "../workflow-step";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowService} from "../workflow.service";
import {DeviceService} from "../../device/device.service";
import {SiteDetailModel, siteDetailModelFactory} from "../../sites/site-detail.model";
import {SiteService} from "../../sites/site.service";

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_LIMIT = 10;

@Component({
  templateUrl: "./site-overview.template.pug",
  providers: [DeviceService],
})

export class SiteOverviewComponent extends WorkflowStep {
  public devices: any[] = [];
  public error: Error;
  public currentPage: number = DEFAULT_PAGE;
  public pageSize: number = DEFAULT_PAGE_LIMIT;
  public maxPages: number;
  public totalCount: number = 0;
  public searchText: string = "";
  public stepName: string = "";
  site: SiteDetailModel = siteDetailModelFactory();

  public ready(): any {
    this.stepName = this.workflowTargetInfo.stepName;
    this.loadData();
  }

  constructor(
    private deviceService: DeviceService,
    public route: ActivatedRoute,
    public router: Router,
    private siteService: SiteService,
    public workflowService: WorkflowService,
  ) {
    super();
  }

  public async loadData() {
    if (!this.workflowTargetInfo.projectId) return;
    this.error = undefined;
    this.deviceService.getDevicesByProjectId(
      +(this.currentPage) - 1,
      +(this.pageSize),
      this.searchText,
      this.workflowTargetInfo.projectId,
      this.workflowTargetInfo.targetId,
    )
      .then(
        ({rows, count}) => {
          this.devices = rows;
          this.maxPages = Math.ceil(count / (+this.pageSize));
          this.totalCount = count;
        },
        (error) => {
          if (error.message === "invalid-echo") return;
          console.error(error);
          this.error = error;
        },
      );
    const siteId = this.workflowService.workflowConfig.targetId;
    this.site = await this.siteService.getSiteById(siteId);
  }

  onListControlsChange(event) {
    switch (event["key"]) {
      case "page":
        this.currentPage = event["value"];
        break;
      case "search":
        this.currentPage = DEFAULT_PAGE;
        this.searchText = event["value"];
        break;
      case "limit":
        this.currentPage = DEFAULT_PAGE;
        this.pageSize = event["value"];
        break;
      default:
        console.info(`Unknown ${event["key"]}`);
        break;
    }
    this.loadData();
  }
}
